import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { CommonAppModule } from '../common-app/common-app.module';
import { LoginBackendComponent } from './login-backend/login-backend.component';
import { SECURITY_MODULE_CONFIG, SecurityModuleConfig } from './security-config';
import { SecurityRoutingModule } from './security-routing.module';
import { AuthenticationBackendService } from './services/authentication-backend.service';
import { AuthenticationBcApiService } from './services/authentication-bc-api.service';
import { AuthorizationTokenService } from './services/authorization-token.service';
import { BridgeTokenConfigProviderService } from './services/bridge-token-config-provider.service';
import { MockAuthorizationTokenService } from './services/mock-autorization-token.service';
import { UserCustomService } from './services/user-custom-service';
import { UserService } from './services/user-service';
import { TokenSecurityInitComponent } from './token-security-init/token-security-init.component';


@NgModule({
  declarations: [
    TokenSecurityInitComponent,
    LoginBackendComponent,
  ],
  exports: [
    TokenSecurityInitComponent,
    LoginBackendComponent
  ],
  imports: [
    CommonModule,
    CommonAppModule,
    SecurityRoutingModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule
  ]
})
export class SecurityModule {
  static forRoot(config: SecurityModuleConfig): ModuleWithProviders<SecurityModule> {
    return {
      ngModule: SecurityModule,
      providers: [
        { provide: SECURITY_MODULE_CONFIG, useValue: config },
        BridgeTokenConfigProviderService,
        { provide: UserService, useClass: UserCustomService },
        { provide: AuthenticationBackendService, useClass: AuthenticationBcApiService }
      ]
    };
  }

  static forRootTesting(): ModuleWithProviders<SecurityModule> {
    return {
      ngModule: SecurityModule,
      providers: [
        MockAuthorizationTokenService,
        { provide: AuthorizationTokenService, useExisting: MockAuthorizationTokenService },
        { provide: UserService, useClass: UserCustomService },
        { provide: AuthenticationBackendService, useClass: AuthenticationBcApiService }
      ]
    };
  }
}
